import i18n from '@/i18n';
import Decimal, { isDecimal } from '@/utils/decimal';

export default function formatAmount(amount: Decimal | number | null) {
  if (amount === undefined || amount === null) return '';
  if (isDecimal(amount)) amount = (amount as Decimal).toNumber();
  amount = amount === 0 ? 0 : amount;
  return i18n.n(amount as number, 'currency');
}
